import { render } from "./AddProceedingView.vue?vue&type=template&id=696b47f7&scoped=true"
import script from "./AddProceedingView.vue?vue&type=script&lang=js"
export * from "./AddProceedingView.vue?vue&type=script&lang=js"

import "./AddProceedingView.vue?vue&type=style&index=0&id=696b47f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696b47f7"]])

export default __exports__